import SourceProductReviewForm from 'SourceComponent/ProductReviewForm/ProductReviewForm.component';
import PropTypes from 'prop-types';

import Field from 'Component/Field';
import { getAllowedFieldsFromProductType } from 'Util/Product';

import { RatingItemsType } from 'Type/Rating';

export default class ProductReviewForm extends SourceProductReviewForm {
    static propTypes = {
        reviewRatings: RatingItemsType.isRequired,
        isLoading: PropTypes.bool.isRequired,
        onReviewSubmitAttempt: PropTypes.func.isRequired,
        onReviewSubmitSuccess: PropTypes.func.isRequired,
        onReviewError: PropTypes.func.isRequired,
        onStarRatingClick: PropTypes.func.isRequired,
        handleNicknameChange: PropTypes.func.isRequired,
        handleEmailChange: PropTypes.func.isRequired,
        handleDetailChange: PropTypes.func.isRequired,
        ratingData: PropTypes.objectOf(PropTypes.number).isRequired,
        reviewData: PropTypes.shape({
            nickname: PropTypes.string,
            email: PropTypes.string,
            detail: PropTypes.string
        }).isRequired,
        householdSkuList: PropTypes.string // New prop from config
    };

    renderButton() {
        return (
            <button
                block="ProductReviewForm"
                elem="Button"
                type="submit"
                mix={ { block: 'Button Button_isPrimary' } }
            >
                { __('Submit Review') }
            </button>
        );
    }

    getCustomerInterval(dob) {
        const diff_ms = Date.now() - new Date(dob).getTime();
        const age_dt = new Date(diff_ms);
        const age = Math.abs(age_dt.getUTCFullYear() - 1970);
        if (age > 55) {
            return 6;
        } if (age > 45) {
            return 5;
        } else if (age > 35) {
            return 4;
        } else if (age > 30) {
            return 3;
        } else if (age > 25) {
            return 2;
        } else if (age > 20) {
            return 1;
        }

        return 0;
    }

    renderReviewFormContent() {
        const {
            handleNicknameChange,
            handleEmailChange,
            handleDetailChange,
            handleAgreementChange,
            handleSubscribeChange,
            reviewData,
            customerAdditionalAttributes: { sex, tip_ten, tip_par },
            customer,
            product,
            isSignedIn,
            householdSkuList
        } = this.props;

        const {
            nickname = '',
            email = '',
            detail = '',
            is_agreement = '',
            is_subscribed = false
        } = reviewData;

        // Build the SKU list from admin config (a comma separated string)
        let hideExtraFieldsSkus = [];
        if (householdSkuList && typeof householdSkuList === 'string') {
            hideExtraFieldsSkus = householdSkuList.split(',').map(sku => sku.trim());
        }
        const shouldShowExtraFields = !hideExtraFieldsSkus.includes(product.sku);

        return (
            <div block="ProductReviewForm" elem="Wrapper">
                <div block="ProductReviewForm" elem="Ratings">
                    { this.renderReviewRating() }
                    <span>{ __("Click on the stars to rate the product") }</span>
                </div>
                <div block="ProductReviewForm" elem="Content">
                    <Field
                        type="textarea"
                        placeholder={ __('Review') }
                        id="detail"
                        name="detail"
                        validation={ [] }
                        value={ detail }
                        onChange={ handleDetailChange }
                    />
                    <div block="Fields" elem="Half">
                        <Field
                            type="text"
                            label={ __('Name') }
                            id="nickname"
                            name="nickname"
                            validation={ ['notEmpty', 'lengthBetween2And15'] }
                            value={ nickname }
                            onChange={ handleNicknameChange }
                        />
                        { !isSignedIn && (
                            <Field
                                type="email"
                                label={ __('Email') }
                                id="email"
                                name="email"
                                validation={ ['email', 'lengthEmail'] }
                                value={ email }
                                onChange={ handleEmailChange }
                            />
                        )}
                        { shouldShowExtraFields && (
                            <>
                                <Field
                                    type="select"
                                    label={ __('Sex') }
                                    id="sex"
                                    name="sex"
                                    placeholder={ __('Choose') }
                                    validation={ ['notEmpty'] }
                                    selectOptions={ sex.attribute_options }
                                    value={ customer.gender }
                                />
                                <Field
                                    type="select"
                                    label={ __('Skin type') }
                                    id="tip_ten"
                                    name="tip_ten"
                                    placeholder={ __('Choose') }
                                    validation={ ['notEmpty'] }
                                    selectOptions={ tip_ten.attribute_options }
                                    value={ customer.tip_ten }
                                />
                                <Field
                                    type="select"
                                    label={ __('Hair type') }
                                    id="tip_par"
                                    name="tip_par"
                                    placeholder={ __('Choose') }
                                    validation={ ['notEmpty'] }
                                    selectOptions={ tip_par.attribute_options }
                                    value={ customer.tip_par }
                                />
                                <Field
                                    type="select"
                                    label={ __('Age') }
                                    id="age"
                                    name="age"
                                    placeholder={ __('Choose') }
                                    validation={ ['notEmpty'] }
                                    selectOptions={ [
                                        { label: '16-19', value: 0 },
                                        { label: '20-24', value: 1 },
                                        { label: '25-29', value: 2 },
                                        { label: '30-34', value: 3 },
                                        { label: '35-44', value: 4 },
                                        { label: '45-54', value: 5 },
                                        { label: '55+', value: 6 }
                                    ] }
                                    value={ this.getCustomerInterval(customer.dob) }
                                />
                            </>
                        )}
                    </div>
                    <Field
                        type="checkbox"
                        label={ __("I agree to <a href='/page/terms-and-conditions' target='_blank'>terms and conditions</a>") }
                        id="is_agreement"
                        name="is_agreement"
                        value={ is_agreement }
                        validation={ ['notEmpty'] }
                        onChange={ () => handleAgreementChange("is_agreement", !is_agreement) }
                    />
                    <Field
                        type="checkbox"
                        label={ __('I wish to subscribe to the Farmec newsletter') }
                        id="is_subscribed"
                        name="is_subscribed"
                        value={ is_subscribed }
                        onChange={ () => handleSubscribeChange("is_subscribed", !is_subscribed) }
                    />
                </div>
            </div>
        );
    }
}
